import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetRegistrationRequestService = () => {
  return HTTP_CLIENT.get(
    `${Endpoint.registrationRequests.getRegistrationRequests}`
  );
};

const VerifyRegistrationService = (id: number, payload: any) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.registrationRequests.verifyRegistration}/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const VerifyPowerSellerService = (id: number, payload: any) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.registrationRequests.verifyPowerSeller}/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export {
  GetRegistrationRequestService,
  VerifyRegistrationService,
  VerifyPowerSellerService,
};
